import { gql } from '@apollo/client';

export const GET_PRODUCTS = gql`
  query GetProducts($input: GetProductsInput!) {
    getProducts(input: $input) {
      products {
        id
        name
        siteIds
        shortDescription

        fullDescription

        instruction

        terms

        image
        countries
        baseCurrencyId
        categoryId
        baseCurrency {
          id
          name
        }
        category {
          id
        }
        preset {
          isPreset
          presetName
        }
      }
      count
    }
  }
`;
